import { Fragment } from "react";
import FAQ from "./Faq's";

export default function DataEnrichments() {
  return (
    <Fragment>
      <FAQ />
    </Fragment>
  );
}
